import type { OktaAuthOptions } from '@okta/okta-auth-js';

import configs from './config';

const { OKTA_DOMAIN, OKTA_CLIENT_ID } = configs;

const CLIENT_ID = OKTA_CLIENT_ID;
const ISSUER = `${OKTA_DOMAIN}/oauth2/default`;
const OKTA_TESTING_DISABLEHTTPSCHECK = true;
const REDIRECT_URI = `${window.location.origin}/login/callback`;

export const OKTA_SCOPES: string[] = [
  'openid',
  'profile',
  'email',
  'offline_access',
];

const oktaOptions: OktaAuthOptions = {
  clientId: CLIENT_ID,
  issuer: ISSUER,
  redirectUri: REDIRECT_URI,
  scopes: OKTA_SCOPES,
  pkce: true,
  // recommended config: https://github.com/okta/okta-auth-js/blob/master/docs/autoRenew-notice.md
  tokenManager: {
    autoRenew: true,
  },
  services: {
    autoRenew: false,
    autoRemove: false,
  },
  // disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
};

const oktaConfig = {
  oidc: oktaOptions,
  resourceServer: {
    messagesUrl: 'http://localhost:8000/api/messages',
  },
  baseUrl: OKTA_DOMAIN,
  useClassicEngine: true,
};

export default oktaConfig;
